module.exports = __webpack_public_path__ + "static/img/Matthew-Dellavedova.d009e91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Matthew-Dellavedova.jpg
// module id = sopk
// module chunks = 1